<template>
  <header>
    <v-app-bar-nav-icon class="d-xl-none d-lg-none d-xl-flex" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    <v-navigation-drawer app width="220px" v-model="drawer">
      <div class="logo_list">
        <div class="logo">
          <img src="@/assets/logo1.png" alt="">
        </div>
      </div>
      <div class="ma-4">
        <div class="d-flex">
          <div class="logo">
            <img width="48" height="48" src="@/assets/user_profile.png" alt="">
          </div>
          <div class="pl-2" style="font-size: 15px !important">
            <div>ยินดีต้อนรับ</div>
            <div>คุณ {{ this.$store.state.userDetail.name }}</div>
          </div>
        </div>
      </div>
      <!-- Admin -->
      <div class="menu_list" v-if="$store.state.status == 1">
        <ul style="width:90%; margin:auto">
          <li v-if="$store.state.status == 1">
            <router-link class="link_menu" to="/" exact :class="{'router-link-active':$route.path == '/'}">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon>mdi-clipboard-text-outline</v-icon>
                </div>
                <div class="title_menu">
                  <div>รายงาน</div>
                </div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link class="link_menu" to="/customer" :class="{'router-link-active':$route.path == '/editemp/' + this.$route.params.id || $route.path == '/addcustomer' || $route.path == '/addcustomercredit' || $route.path == '/retailer' || $route.path == '/admin' || $route.path == '/addadmin' || $route.path == '/partner'}">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon>mdi-account-multiple</v-icon>
                </div>
                <div class="title_menu">
                  <div>สมาชิก</div>
                </div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link class="link_menu" to="/stock" :class="{'router-link-active': $route.path == '/stock/document/governmentreceipt' || $route.path == '/stock/manage_product/productlist' || $route.path == '/stock/promotion_stock/promotionexp' || $route.path == '/setting/productsetting' || $route.path == '/setting/unitsetting' || $route.path == '/warehousereport' || $route.path == '/warehousequantity/' + this.$route.params.id}">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon>mdi-cube-outline</v-icon>
                </div>
                <div class="title_menu">
                  <div>คลัง</div>
                </div>
              </div>
            </router-link>
          </li>
          <li v-if="$store.state.userDetail.manage_stock == 1 || $store.state.userDetail.manage_stock_barcode == 1 || $store.state.userDetail.manage_stock_count == 1 || $store.state.userDetail.manage_stock_create == 1">
            <router-link class="link_menu" to="/count_stock/historylist" :class="{'router-link-active': $route.path == '/count_stock/countcreate' || $route.path == '/count_stock/countstock' || $route.path == ('/count_stock/countdetails/'+ $route.params.id) || $route.path == ('/count_stock/countclose/'+ $route.params.id) || $route.path == '/count_stock/uploadbarcode'}">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon>mdi-package</v-icon>
                </div>
                <div class="title_menu">
                  <div>นับสต๊อก</div>
                </div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link class="link_menu" to="/purchase" :class="{'router-link-active': $route.path == '/addpurchase' || $route.path == '/supplier' || $route.path == '/addsupplier' || $route.path == '/confirmaddpurchase'}">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon>mdi-cart-outline</v-icon>
                </div>
                <div class="title_menu">
                  <div>ซื้อ </div>
                </div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link class="link_menu" to="/sell/all" :class="{'router-link-active': $route.path == '/sell/sellreport' || $route.path == '/sell/createorderother' || $route.path == '/sell/orderothereditlots/' + this.$route.params.id || $route.path == '/sell/orderotherdetail/' + this.$route.params.id || $route.path == '/sell/orderpartnereditlots/' + this.$route.params.id || $route.path == '/sell/confirmpartneredit/' + this.$route.params.id || $route.path == '/sell/orderpartneredit/' + this.$route.params.id || $route.path == '/sell/orderpartnerdetail/' + this.$route.params.id || $route.path == '/sell/ordercustomereditlots/' + this.$route.params.id || $route.path == '/sell/confirmcustomerdetail/' + this.$route.params.id || $route.path == '/sell/paycustomerincorrect/' + this.$route.params.id || $route.path == '/sell/orderidentify/' + this.$route.params.id || $route.path == '/sell/ordercustomeredit/' + this.$route.params.id || $route.path == '/sell/ordercustomerdetail/' + this.$route.params.id || $route.path == '/sell/confirmorderdetail/' + this.$route.params.id || $route.path == '/sell/orderretailcustomers' || $route.path == '/sell/orderretaildetail/' + this.$route.params.id || $route.path == '/sell/payincorrect/' + this.$route.params.id || $route.path == '/sell/confirmorderdetail/' + this.$route.params.id + '/' + this.$route.params.status || $route.path == '/sell/orderretailedit/' + this.$route.params.id || $route.path == '/sell/ordercustomermain' || $route.path == '/sell/orderpartnermain' || $route.path == '/sell/orderothermain' || $route.path == '/refund/refundwaitforprocess' || $route.path == '/refund/refundprocesssuccess' || $route.path == '/refund/refunddetail/' + this.$route.params.id}">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon>mdi-cash-100</v-icon>
                </div>
                <div class="title_menu">
                  <div>ขาย  <v-badge  v-if="newOrderCount !== null"   v-show="newOrderCount > 0" color="red" :content="newOrderCount" inline class="ml-15 blinking"/></div>
                </div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link class="link_menu" to="/creditor/all" :class="{'router-link-active': $route.path == '/creditor/reportdebtordetail/' + this.$route.params.id || $route.path == '/creditor/transferincorrect/' + this.$route.params.id || $route.path == '/creditor/transfercorrect/' + this.$route.params.id || $route.path == '/creditor/transferdebtordetail/' + this.$route.params.id || $route.path == '/creditor/transferfromdebtor' || $route.path == '/creditor/reportdebtor' || $route.path == '/creditor/pudetailspr/' + this.$route.params.id || $route.path == '/creditor/pumain/' + this.$route.params.month + '/' + this.$route.params.year || $route.path == '/creditor/report' || $route.path == '/creditor/all' || $route.path == '/creditor/puinvoice' || $route.path == '/creditor/pumain' || $route.path == '/creditor/pudetails/' + this.$route.params.id}">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon>mdi-trending-up</v-icon>
                </div>
                <div class="title_menu">
                  <div>เจ้าหนี้, ลูกหนี้</div>
                </div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link class="link_menu" to="/managewebsite" :class="{'router-link-active': $route.path == '/coversetting' || $route.path == '/bannersetting' || $route.path == '/companyinformation' || $route.path == '/contactinformation' || $route.path == '/branchinformation' || $route.path == '/ratesetting' || $route.path == '/transfersetting' || $route.path == '/articlemanage' || $route.path == '/articleadd' || $route.path == '/articleedit' + '/' + this.$route.params.id || $route.path == '/faqspage' || $route.path == '/faqsadd' || $route.path == '/faqsedit' + '/' + this.$route.params.id || $route.path == '/policypage' || $route.path == '/contractpage' || $route.path == '/logopage'}">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon>mdi-application-cog-outline</v-icon>
                </div>
                <div class="title_menu">
                  <div>จัดการเว็บไซต์</div>
                </div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link class="link_menu" to="/managepos" :class="{'router-link-active': $route.path == '/reportwholesale' || $route.path == '/promotioninformation' || $route.path == '/newsinformation' || $route.path == '/setpriceinfomation' || $route.path == '/reportinformation' || $route.path == '/promotionaddposfree' || $route.path == '/promotioneditposfree' || $route.path == '/promotioneditposprice' || $route.path == '/promotionaddposprice' || $route.path == '/setcreditinformation' }">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon>mdi-application-cog-outline</v-icon>
                </div>
                <div class="title_menu">
                  <div>จัดการ POS</div>
                </div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link class="link_menu" to="/profile">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon>mdi-account-circle</v-icon>
                </div>
                <div class="title_menu">
                  <div>ข้อมูลส่วนตัว</div>
                </div>
              </div>
            </router-link>
          </li>
          <li>
            <div class="link_menu" style="cursor:pointer;" @click="logout()">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon>mdi-logout</v-icon>
                </div>
                <div class="title_menu">
                  <div>ออกจากระบบ</div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- Employee -->
      <div class="menu_list" v-else-if="$store.state.status == 2">
        <ul style="width:90%; margin:auto">
          <li>
            <router-link class="link_menu" to="/customer" :class="{'router-link-active':$route.path == '/editemp/' + this.$route.params.id || $route.path == '/addcustomer' || $route.path == '/addcustomercredit' || $route.path == '/retailer' || $route.path == '/admin' || $route.path == '/addadmin' || $route.path == '/partner'}">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon>mdi-account-multiple</v-icon>
                </div>
                <div class="title_menu">
                  <div>สมาชิก</div>
                </div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link class="link_menu" to="/stock" :class="{'router-link-active': $route.path == '/stock/document/governmentreceipt' || $route.path == '/stock/manage_product/productlist' || $route.path == '/stock/promotion_stock/promotionexp' || $route.path == '/setting/productsetting' || $route.path == '/setting/unitsetting' || $route.path == '/warehousereport' || $route.path == '/warehousequantity/' + this.$route.params.id}">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon>mdi-cube-outline</v-icon>
                </div>
                <div class="title_menu">
                  <div>คลัง</div>
                </div>
              </div>
            </router-link>
          </li>
          <li v-if="$store.state.userDetail.manage_stock == 1 || $store.state.userDetail.manage_stock_barcode == 1 || $store.state.userDetail.manage_stock_count == 1 || $store.state.userDetail.manage_stock_create == 1">
            <router-link class="link_menu" to="/count_stock/historylist" :class="{'router-link-active': $route.path == '/count_stock/countcreate' || $route.path == '/count_stock/countstock' || $route.path == ('/count_stock/countdetails/'+ $route.params.id) || $route.path == ('/count_stock/countclose/'+ $route.params.id) || $route.path == '/count_stock/uploadbarcode'}">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon>mdi-package</v-icon>
                </div>
                <div class="title_menu">
                  <div>นับสต๊อก</div>
                </div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link class="link_menu" to="/purchase" :class="{'router-link-active': $route.path == '/addpurchase' || $route.path == '/supplier' || $route.path == '/addsupplier' || $route.path == '/confirmaddpurchase'}">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon>mdi-cart-outline</v-icon>
                </div>
                <div class="title_menu">
                  <div>ซื้อ</div>
                </div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link class="link_menu" to="/sell/all" :class="{'router-link-active': $route.path == '/sell/sellreport' || $route.path == '/sell/createorderother' || $route.path == '/sell/orderothereditlots/' + this.$route.params.id || $route.path == '/sell/orderotherdetail/' + this.$route.params.id || $route.path == '/sell/orderpartnereditlots/' + this.$route.params.id || $route.path == '/sell/confirmpartneredit/' + this.$route.params.id || $route.path == '/sell/orderpartneredit/' + this.$route.params.id || $route.path == '/sell/orderpartnerdetail/' + this.$route.params.id || $route.path == '/sell/ordercustomereditlots/' + this.$route.params.id || $route.path == '/sell/confirmcustomerdetail/' + this.$route.params.id || $route.path == '/sell/paycustomerincorrect/' + this.$route.params.id || $route.path == '/sell/orderidentify/' + this.$route.params.id || $route.path == '/sell/ordercustomeredit/' + this.$route.params.id || $route.path == '/sell/ordercustomerdetail/' + this.$route.params.id || $route.path == '/sell/confirmorderdetail/' + this.$route.params.id || $route.path == '/sell/orderretailcustomers' || $route.path == '/sell/orderretaildetail/' + this.$route.params.id || $route.path == '/sell/payincorrect/' + this.$route.params.id || $route.path == '/sell/confirmorderdetail/' + this.$route.params.id + '/' + this.$route.params.status || $route.path == '/sell/orderretailedit/' + this.$route.params.id || $route.path == '/sell/ordercustomermain' || $route.path == '/sell/orderpartnermain' || $route.path == '/sell/orderothermain' || $route.path == '/refund/refundwaitforprocess' || $route.path == '/refund/refundprocesssuccess' || $route.path == '/refund/refunddetail/' + this.$route.params.id}">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon>mdi-cash-100</v-icon>
                </div>
                <div class="title_menu">
                  <div>ขาย <v-badge  v-if="newOrderCount !== null"   v-show="newOrderCount > 0" color="red" :content="newOrderCount" inline class="ml-15 blinking" /></div>
                </div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link class="link_menu" to="/creditor/all" :class="{'router-link-active': $route.path == '/creditor/reportdebtordetail/' + this.$route.params.id || $route.path == '/creditor/transferincorrect/' + this.$route.params.id || $route.path == '/creditor/transfercorrect/' + this.$route.params.id || $route.path == '/creditor/transferdebtordetail/' + this.$route.params.id || $route.path == '/creditor/transferfromdebtor' || $route.path == '/creditor/reportdebtor' || $route.path == '/creditor/pumain/' + this.$route.params.month + '/' + this.$route.params.year || $route.path == '/creditor/report' || $route.path == '/creditor/all' || $route.path == '/creditor/puinvoice' || $route.path == '/creditor/pumain' || $route.path == '/creditor/pudetails/' + this.$route.params.id}">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon>mdi-trending-up</v-icon>
                </div>
                <div class="title_menu">
                  <div>เจ้าหนี้, ลูกหนี้</div>
                </div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link class="link_menu" to="/managewebsite" :class="{'router-link-active': $route.path == '/coversetting' || $route.path == '/bannersetting' || $route.path == '/companyinformation' || $route.path == '/contactinformation' || $route.path == '/branchinformation' || $route.path == '/ratesetting' || $route.path == '/transfersetting' || $route.path == '/articlemanage' || $route.path == '/articleadd' || $route.path == '/articleedit' + '/' + this.$route.params.id || $route.path == '/faqspage' || $route.path == '/faqsadd' || $route.path == '/faqsedit' + '/' + this.$route.params.id || $route.path == '/policypage' || $route.path == '/contractpage' || $route.path == '/logopage'}">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon>mdi-application-cog-outline</v-icon>
                </div>
                <div class="title_menu">
                  <div>จัดการเว็บไซต์</div>
                </div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link class="link_menu" to="/profile">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon>mdi-account-circle</v-icon>
                </div>
                <div class="title_menu">
                  <div>ข้อมูลส่วนตัว</div>
                </div>
              </div>
            </router-link>
          </li>
          <li>
            <div class="link_menu" style="cursor:pointer;" @click="logout()">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon>mdi-logout</v-icon>
                </div>
                <div class="title_menu">
                  <div>ออกจากระบบ</div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- Stock open -->
<!--      <div class="menu_list" v-else-if="$store.state.userDetail.manage_stock == 1 && $store.state.status == 2 || $store.state.userDetail.manage_stock_barcode == 1 && $store.state.status == 2 || $store.state.userDetail.manage_stock_count == 1 && $store.state.status == 2 || $store.state.userDetail.manage_stock_create == 1 && $store.state.status == 2">-->
<!--        <ul style="width:90%; margin:auto">-->
<!--          <li>-->
<!--            <router-link class="link_menu" to="/count_stock/historylist">-->
<!--              <div class="d-flex card_menu py-2">-->
<!--                <div class="icon_menu">-->
<!--                  <v-icon>mdi-package</v-icon>-->
<!--                </div>-->
<!--                <div class="title_menu">-->
<!--                  <div>นับสต๊อก</div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </router-link>-->
<!--          </li>-->
<!--          <li>-->
<!--            <div class="link_menu" style="cursor:pointer;" @click="logout()">-->
<!--              <div class="d-flex card_menu py-2">-->
<!--                <div class="icon_menu">-->
<!--                  <v-icon>mdi-logout</v-icon>-->
<!--                </div>-->
<!--                <div class="title_menu">-->
<!--                  <div>ออกจากระบบ</div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </li>-->
<!--        </ul>-->
<!--      </div>-->
    </v-navigation-drawer>
  </header>
</template>

<script>
import {HTTP} from "@/axios";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      drawer: null,
      newOrderCount: null, // ให้รู้ว่ายังไม่โหลด
    }
  },
  methods: {
    async logout() {
      await Swal.fire({
        title: 'คุณต้องการออกจากระบบหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((result) => {
        if (result.isConfirmed === true) {
          this.$store.commit('logout_success')
          this.$router.push('/login')
        }
      });
    },
    async fetchNewOrderCount() {
      try {
        const res = await HTTP.get('/wholesales/orders/count-new')
        this.newOrderCount = res.data.count
      } catch (error) {
        console.error('Fetch order count failed', error)
      }
    }
  },
  mounted() {
    this.fetchNewOrderCount()
    this.orderInterval = setInterval(this.fetchNewOrderCount, 10000) // ทุก 10 วิ
  },
  beforeDestroy() {
    clearInterval(this.orderInterval)
  }
}
</script>

<style scoped>
.blinking {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0.4;
  }
}

.logo_list {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
}

.logo_list>.logo {
  padding-top: 30px;
  width: 180px;
}

.logo_list>.logo>img {
  max-width: 100%;
}

.menu_list>ul {
  list-style: none;
  padding: 0;
}

.menu_list>ul>li {
  padding: 5px;
}

.link_menu {
  text-decoration: none;
  display: block;
  color: #565656;
  border-radius: 4px;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12) !important;
}

.icon_menu {
  margin-left: 10px;
  align-self: center;
}

.title_menu {
  margin-left: 10px;
}

.link_menu:hover {
  background: #8cc63e;
  transition: 0.1s !important;
}

.link_menu:hover>.card_menu>.icon_menu>i,
.link_menu:hover>.card_menu>.title_menu {
  color: #ffffff;
  transition: 0.1s !important;
}

.router-link-active {
  background-image: linear-gradient(to right, #8cc63e, #91c657, #9cc66d);
  transition: 0.1s !important;
}

.router-link-active>.card_menu>.icon_menu>i,
.router-link-active>.card_menu>.title_menu {
  color: #ffffff;
  transition: 0.1s !important;
}
</style>
